// extracted by extract-css-chunks-webpack-plugin
module.exports = {"disabled":"input-phone__disabled--1hVLC"};